// extracted by mini-css-extract-plugin
module.exports = {"spinner-wrapper":"spinner_spinner-wrapper__1QDZ4","spinner-ring":"spinner_spinner-ring__25eqe","spinner":"spinner_spinner__1v2aB","spinnerLoader":"spinner_spinnerLoader__3yrOg"};